import {axios} from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  findPolicyList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post('/policy/findPolicyList', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  savePolicy({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`policy/savePolicy`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  delPolicy({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/policy/delPolicy",
        params: params
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

}
